export const DATA_HANDLE = 'tangocard'
export const SCRIPT_TYPE = 'text/javascript'
export const SCRIPT_ID = '__ada'
export const SCRIPT_SRC = 'https://static.ada.support/embed2.js'
